import React from 'react'
import { Modal } from 'antd'
import { FilterFilled } from '@ant-design/icons'
import { ColumnType } from 'antd/es/table'
import styles from './MobileFilterTitle.module.scss'

interface IMobileFilterTitleProps {
  title: React.ReactNode
  // колонки, чьи фильтры остались без своей шапки после объединения колонок
  columns: (ColumnType<any> | undefined)[]
  isActive?: boolean
}

// Фильтры объединённой колонки открываются модалкой: поповер antd на узком
// экране прижимается к краю таблицы и обрезается
export const MobileFilterTitle: React.FC<IMobileFilterTitleProps> = ({
  title,
  columns,
  isActive
}) => {
  const [isOpen, setIsOpen] = React.useState(false)
  const close = () => setIsOpen(false)

  const filters = columns.filter(
    (column): column is ColumnType<any> => typeof column?.filterDropdown === 'function'
  )

  if (!filters.length) {
    return <>{title}</>
  }

  return (
    <>
      <span className={styles.title} onClick={() => setIsOpen(true)}>
        {title}
        <FilterFilled className={isActive ? styles.iconActive : styles.icon} />
      </span>
      <Modal
        open={isOpen}
        onCancel={close}
        title={title}
        footer={null}
        centered
        destroyOnClose
      >
        {filters.map((column, index) => (
          <div key={index} className={styles.section}>
            {filters.length > 1 && typeof column.title !== 'function' && (
              <div className={styles.sectionTitle}>{column.title}</div>
            )}
            {(column.filterDropdown as (props: any) => React.ReactNode)({ close })}
          </div>
        ))}
      </Modal>
    </>
  )
}
